<ng-container *transloco="let t">
  <div class="step-container">
    <div class="step-content">
      <button class="back-button" (click)="back.emit()" type="button">
        <mzic-svg src="assets/icons/arrow-left-disabled.svg" />
      </button>

      <div class="setup">
        <div class="setup-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M12 3l8 3v6c0 4.5-3.4 8.3-8 9-4.6-.7-8-4.5-8-9V6z"></path>
            <path d="M12 9v6"></path>
            <path d="M9 12h6"></path>
          </svg>
        </div>

        <h1 class="setup-title">{{ t('lang.provider_setup_required_title') }}</h1>

        @if (
          descriptionParts(
            t('lang.provider_setup_required_description', emphasisParams)
          );
          as parts
        ) {
          <p class="setup-description">
            {{ parts[0] }}@if (parts[1]) {<strong>{{ parts[1] }}</strong>}{{ parts[2] }}
          </p>
        }

        <ol class="setup-steps">
          @for (key of stepKeys; track key; let index = $index) {
            <li class="setup-step">
              <span class="setup-step-number" aria-hidden="true">{{ index + 1 }}</span>
              <span>{{ t(key, { provider: providerName }) }}</span>
            </li>
          }
        </ol>
      </div>
    </div>

    <div class="step-footer">
      <button class="primary-button" (click)="retry.emit()" type="button">
        {{ t('lang.provider_setup_required_retry') | uppercase }}
      </button>
    </div>
  </div>
</ng-container>
